import { LoanStage } from "@toorak/tc-common-fe-sdk";
import { isLoanOnHold } from "./AccessManagement";
import { LoanStatusEnum } from "@toorak/tc-common-util-sdk";
import { dispatchAndUpdate } from "../create-loan/create-loan.action";
import { TABLE_FUNDING } from "./constants";

export const canBeMovedToReviewInProgress = (
  loanId: string,
  isDSCR: boolean,
  loanDetails: any,
  loanEvaluationResult: any,
  useSummary = false
) => {
  const isTf = loanDetails?.loanDetailId?.fundingType === TABLE_FUNDING;
  const loanStage = loanDetails?.loanStage;
  let teamIndiaTapetoFile =
    loanDetails?.loanDetailId?.loanSummaryId?.teamIndiaTapetoFile;
  let ttfReviewStatus =
    loanDetails?.loanDetailId?.loanSummaryId?.ttfReviewStatus;
  let enhancedReview = loanDetails?.loanDetailId?.loanSummaryId?.enhancedReview;
  if (useSummary) {
    teamIndiaTapetoFile = loanDetails?.loanSummary?.teamIndiaTapetoFile;
    ttfReviewStatus = loanDetails?.loanSummary?.ttfReviewStatus;
    enhancedReview = loanDetails?.loanSummary?.enhancedReview;
  }

  let canMoveToReviewInProgress = !isLoanOnHold(loanDetails?.onHoldBy) &&
    loanDetails.loanState === LoanStatusEnum.InitialReview;

  const loanResult = loanEvaluationResult?.loanResult?.[loanId]?.loanCharacterisations;
  const needEnhancedReview = loanResult?.needEnhancedReview;
  const isTeamIndiaTapetoFileYes = ["Yes", "Overridden"].includes(teamIndiaTapetoFile);
  const isTTFComplete = ttfReviewStatus === "Completed";
  const isEnhancedReviewYes = ["Yes", "Overridden"].includes(enhancedReview);
  if (!canMoveToReviewInProgress) return false;
  
  if (!isDSCR) {
    if (loanStage === LoanStage.pre) {
    canMoveToReviewInProgress = (needEnhancedReview !== "Yes" && isTeamIndiaTapetoFileYes) ||
      (needEnhancedReview === "Yes" && isTeamIndiaTapetoFileYes && isEnhancedReviewYes);
    } else if (loanStage === LoanStage.post) {
      canMoveToReviewInProgress = (needEnhancedReview !== "Yes" && isTTFComplete) ||
        (needEnhancedReview === "Yes" && isTTFComplete && isEnhancedReviewYes);
    }
  } else {
    const takeoutPartner = loanDetails?.thirtyYearLoanInformation?.payload?.takeoutPartnerId;
    const takeoutPartnerStatus = loanDetails?.thirtyYearLoanInformation?.payload?.takeoutPartnerStatus;

    canMoveToReviewInProgress = takeoutPartner != null &&
      takeoutPartnerStatus !== "PENDING" && isTf && isEnhancedReviewYes;
  }
  return canMoveToReviewInProgress;
};

export const moveToReviewInProgress = (
  loanId: string,
  loanStage: LoanStage,
  isDSCR: boolean,
  loanDetails: any,
  loanEvaluationResult: any,
  dispatch: any,
  comments: string,
  useSummary = false
) => {
  if (
    canBeMovedToReviewInProgress(
      loanId,
      isDSCR,
      loanDetails,
      loanEvaluationResult,
      useSummary
    )
  ) {
    const moveToRIPCallBack = dispatchAndUpdate(
      loanId,
      LoanStatusEnum.DueDiligenceReview,
      loanStage,
      dispatch,
      comments,
      true
    );
    moveToRIPCallBack(dispatch);
  }
};
